export interface ContactSettingsProps {
  id: string;
  isEnabled: boolean;
  autoReplyEnabled: boolean;
  autoReplySubject: string;
  autoReplyMessage: string;
  notificationSubjectPrefix: string;
  createdAt: Date;
  updatedAt: Date;
}

export class ContactSettings {
  private readonly _id: string;
  private _isEnabled: boolean;
  private _autoReplyEnabled: boolean;
  private _autoReplySubject: string;
  private _autoReplyMessage: string;
  private _notificationSubjectPrefix: string;
  private readonly _createdAt: Date;
  private _updatedAt: Date;

  private constructor(props: ContactSettingsProps) {
    this._id = props.id;
    this._isEnabled = props.isEnabled;
    this._autoReplyEnabled = props.autoReplyEnabled;
    this._autoReplySubject = props.autoReplySubject;
    this._autoReplyMessage = props.autoReplyMessage;
    this._notificationSubjectPrefix = props.notificationSubjectPrefix;
    this._createdAt = props.createdAt;
    this._updatedAt = props.updatedAt;
  }

  public static create(props: {
    id: string;
    isEnabled?: boolean;
    autoReplyEnabled?: boolean;
    autoReplySubject?: string;
    autoReplyMessage?: string;
    notificationSubjectPrefix?: string;
    createdAt?: Date | string;
    updatedAt?: Date | string;
  }): ContactSettings {
    return new ContactSettings({
      id: props.id,
      isEnabled: props.isEnabled ?? true,
      autoReplyEnabled: props.autoReplyEnabled ?? true,
      autoReplySubject: props.autoReplySubject || 'Hemos recibido tu consulta - BARTECH',
      autoReplyMessage: props.autoReplyMessage || 'Gracias por comunicarte con nosotros.',
      notificationSubjectPrefix: props.notificationSubjectPrefix || '[Nuevo Contacto Web]',
      createdAt: props.createdAt ? new Date(props.createdAt) : new Date(),
      updatedAt: props.updatedAt ? new Date(props.updatedAt) : new Date(),
    });
  }

  public get id(): string {
    return this._id;
  }

  public get isEnabled(): boolean {
    return this._isEnabled;
  }

  public get autoReplyEnabled(): boolean {
    return this._autoReplyEnabled;
  }

  public get autoReplySubject(): string {
    return this._autoReplySubject;
  }

  public get autoReplyMessage(): string {
    return this._autoReplyMessage;
  }

  public get notificationSubjectPrefix(): string {
    return this._notificationSubjectPrefix;
  }

  public get createdAt(): Date {
    return this._createdAt;
  }

  public get updatedAt(): Date {
    return this._updatedAt;
  }
}
